import { useEffect } from 'react';

// Prefetch likely next routes on idle to reduce cold-hit LCP
const RoutePrefetcher = () => {
  useEffect(() => {
    const canPrefetch = () => {
      try {
        const conn = (navigator as any).connection;
        if (conn?.saveData) return false;
        const type = conn?.effectiveType || '4g';
        return ['4g'].includes(type);
      } catch { return true; }
    };

    const schedule = () => {
      // Defer prefetch until after load + extra delay
      const start = async () => {
        if (!canPrefetch()) return;
        try {
          await Promise.all([
            import('../pages/MealPlannerPage'),
            import('../pages/PreferencesPage'),
            import('../pages/SubscriptionPage'),
          ]);
        } catch {}
      };
      if ('requestIdleCallback' in window) {
        (window as any).requestIdleCallback(() => setTimeout(start, 2500), { timeout: 5000 });
      } else {
        // After full load + delay
        (window as Window).addEventListener('load', () => setTimeout(start, 2500), { once: true });
      }
    };

    schedule();
  }, []);
  return null;
};

export default RoutePrefetcher;
